import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/HomePage/home.js";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useSelector } from "react-redux";
import { Analytics } from "@vercel/analytics/react";
import { darkTheme, lightTheme } from "./utilities/commonUtils.js";
import ScrollToTop from "./utilities/scrolltotop.js";
import AnalyticsBootstrap from "./components/Analytics/AnalyticsBootstrap.jsx";

const Login = lazy(() => import("./components/Login/login.js"));
const BlogView = lazy(() => import("./components/BlogView/blogview.js"));
const CreateBlog = lazy(() => import("./components/CreateBlog/postblog.js"));
const SavedBlogs = lazy(() => import("./components/SavedBlogs/savedBlogs.js"));
const ProtectedRoute = lazy(
  () => import("./components/ProtectedRoute/protectedRoute.js"),
);
const UserProfile = lazy(() => import("./components/UserProfile/userProfile.js"));
const UserBlogs = lazy(() => import("./components/UserBlogs/userBlogs.js"));
const AdminPage = lazy(() => import("./modules/admin/AdminPage.jsx"));
const LegalPage = lazy(() => import("./components/Legal/LegalPage.jsx"));

const App = () => {
  const mode = useSelector((state) => state.blogs.appTheme);
  const appTheme = JSON.parse(localStorage.getItem("theme")) || mode;

  return (
    <ThemeProvider theme={appTheme ? darkTheme : lightTheme}>
      <Analytics />
      <CssBaseline />
      <ScrollToTop />
      <AnalyticsBootstrap />

      <Suspense fallback={null}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/login" element={<Login />} />
          <Route
            exact
            path="/terms-and-conditions"
            element={<LegalPage documentKey="terms" />}
          />
          <Route
            exact
            path="/privacy-policy"
            element={<LegalPage documentKey="privacy" />}
          />
          <Route exact path="/blogs/:id" element={<BlogView />} />
          <Route exact path="/" element={<ProtectedRoute />}>
            <Route exact path="/createblog" element={<CreateBlog />} />
            <Route exact path="/user/saved" element={<SavedBlogs />} />
            <Route exact path="/user/profile" element={<UserProfile />} />
            <Route exact path="/user/blogs" element={<UserBlogs />} />
            <Route exact path="/admin" element={<AdminPage />} />
          </Route>
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
};
//APP MODIFIED
export default App;
